import OaApiService from './OaApiService';

export default class AgencyService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.getByIdUrl = '/AgencyREST/details-id';
    this.getByKeyUrl = '/AgencyREST/details-key';
  }

  getByName(agencyName) {
    return new Promise((resolve, reject) => {
      this.get('/AgencyRest/find', {}, agencyName)
        .then((agencies) => {
          resolve(agencies);
        })
        .catch((error) => {
          // This endpoint returns false when there is no agency match
          // We don't want to throw an error in that case but expect an empty array instead
          if (error === 'No Agencies Found') {
            resolve([]);
          } else {
            reject(error);
          }
        });
    });
  }
}
